module.exports = __webpack_public_path__ + "img/1_2024_08_23.a24e4134.jpg";